import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	ONBOARDING_INTENT_EXPERIENCES,
	ONBOARDING_EXPERIENCES,
} from '../../constants/onboarding-state/onboarding-constants.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadIntentBasedOnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: Object.values({
				...ONBOARDING_INTENT_EXPERIENCES,
				...ONBOARDING_EXPERIENCES,
			}),
		},
	});
};
